import React from "react";
import "./TextBlock.scss"; // Import your stylesheet

const TextBlock = ({ title, description }) => {
  return (
    <section className="text-block">
        <div className="text-block__text">
          <h3>{title}</h3>
          <h5>{description}</h5>
          </div>
    </section>
  );
};

export default TextBlock;
